
import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import { Check } from "lucide-react"; // Ensure lucide-react is installed

export const ProgressBar = ({ currentStep = 0, totalSteps = 4 }) => {
  // Define the routes for each step.
  // You can also derive these from your getStartedConfig if needed.
  const stepRoutes = [
    "/get-started/step1",
    "/get-started/step2",
    "/get-started/step3",
    "/get-started/step4"
  ];

  return (
    <div className="progress-bar-container">
      {/* Track and fill */}
      <div className="progress-track">
        <div
          className="progress-fill"
          style={{
            width: `${(currentStep / (totalSteps - 1)) * 100}%`
          }}
        />
      </div>
      {/* Clickable circles as links */}
      <div className="progress-circles">
        {Array.from({ length: totalSteps }).map((_, index) => {
          const isCompleted = index < currentStep;
          const isActive = index === currentStep;
          return (
            <Link
              key={index}
              to={stepRoutes[index]}
              className={`circle ${isCompleted ? "completed" : ""} ${isActive ? "active" : ""}`}
            >
              {isCompleted && <Check className="tick-icon" size={20} />}
            </Link>
          );
        })}
      </div>
    </div>
  );
};


// InlineBox Component
export const InlineBox = ({ title, children }) => {
  return (
    <div className="col">

    <div className="inline-box">
      <h4>{title}</h4>
      <div className="box-content">{children}</div>
    </div>
    </div>
  );
};

// ImageInline Component
export const ImageInline = ({ imageSrc, alt, annotations }) => {
  return (
    <div className="grid-fixed g2">
      <div className="col one-third">

      <img src={imageSrc} alt={alt} className="col one-third" />
      </div>
      <div className="col not-one-third">{annotations}</div>
    </div>
  );
};

// MainContent Component (using guides-content styles)
export const MainContent = ({ children }) => {
  return <div className="guides-content  guides-content-pad get-started-content">{children}</div>;
};

// GuideStep Component - a sample step in the guide
export const GuideStep = ({ step, content, inlineInfo, imageInfo, nextPath }) => {
  const navigate = useNavigate();
  // Define a mapping from step index to route
  const stepRoutes = ["/get-started/step1", "/get-started/step2", "/get-started/step3", "/get-started/step4"];

  // When a progress circle is clicked, navigate to that step's route
  const handleStepClick = (stepIndex) => {
    navigate(stepRoutes[stepIndex]);
  };

  return (
    <MainContent>
      <ProgressBar currentStep={step} onStepClick={handleStepClick} />
      <h1>Step {step + 1}</h1>
      <p>{content}</p>

      {inlineInfo && (
        <div className="inline-box-container">
          {inlineInfo.map((info, idx) => (
            <InlineBox key={idx} title={info.title}>
              {info.body}
            </InlineBox>
          ))}
        </div>
      )}

      {imageInfo && (
        <ImageInline
          imageSrc={imageInfo.src}
          alt={imageInfo.alt}
          annotations={imageInfo.annotations}
        />
      )}

      {nextPath && (
        <button className="next-button" onClick={() => navigate(nextPath)}>
          Next →
        </button>
      )}
    </MainContent>
  );
};




export const VerticalBox = ({ index, content }) => {
  const backgroundColor = index === 0 ? "var(--secondary)" : "#666";

  return (
    <div className="vertical-box">
      <div
        className="vertical-box-icon"
        style={{ backgroundColor }}
      />
      <div className="vertical-box-content">
        {content}
      </div>
    </div>
  );
};

export default VerticalBox;


export const VerticalTimeline = ({ props }) => {
  return (
    <div className="vertical-timeline">
      {props.timelineData.map((item, index) => {
        const timelineItem = (
          <VerticalBox key={index} index={index} content={item.content} />
        );

        return item.link ? (
          <Link to={item.link} className="vertical-box-link" key={index}>
            {timelineItem}
          </Link>
        ) : (
          timelineItem
        );
      })}
    </div>
  );
};

export const VerticalBoxInner = ({ icon, title, description }) => {
  return (
    <div className="vertical-box-inner">
      <div className="vertical-box-header">
        <h4>
          {icon} {title}
        </h4>
      </div>
      <div className="vertical-box-body">
        <p>{description}</p>
      </div>
    </div>
  );
};